import HeaderChatPanel from './ChatPanelContent'

export default HeaderChatPanel